export const reorderArray = (index, newIndex, data) => {
  const movedItem = data.find((item, i) => i === index)
  const remainingItems = data.filter((item, i) => i !== index)

  return [...remainingItems.slice(0, newIndex), movedItem, ...remainingItems.slice(newIndex)]
}
